import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import type { LoyaltyConfiguration } from 'src/app/pages/marketing/loyalty/loyalty-tiers/models/loyalty-models';

export type LoyaltyDetailsResponse = LoyaltyConfiguration;

export const loyaltyDetailsQueryKey = ['loyalty-details'];

export function useGetLoyaltyDetails() {
  return useQuery({
    queryKey: loyaltyDetailsQueryKey,
    staleTime: 0,
    queryFn: async () => fetchData<LoyaltyDetailsResponse>('api/loyalty/get-details'),
    refetchInterval: false,
  });
}
